$('.image-slider').slick({
  prevArrow: "<div class='slider-nav-left slider-nav-left-hide'>&larr;</div>",
  nextArrow: "<div class='slider-nav-right slider-nav-right-hide'>&rarr;</div>",
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  lazyLoad: 'progressive',
  responsive: [
    {
      breakpoint: 980,
      settings: {
        
      }
    },
    {
      breakpoint: 768,
      settings: {
	    lazyLoad: 'ondemand'
      }
    }
  ]
});